import { Pipe, PipeTransform } from '@angular/core';
import Enums from '@xbs/xbs-enums';
/**
 * Use this pipe to keep desired number values to XBS's standard TBA PLI format.
 */

@Pipe({ name: 'xbsTbaPliFormat' })
export class xbsTbaPliFormatPipe implements PipeTransform {

  constructor() { }

  transform(value: any, pliType: string): string {
    if (value !== 0 && !value) {
      return '';
    }
    
    let formatted;
    const isDecimal = Enums.TbaPliDisplayFormats.ByName[pliType] && Enums.TbaPliDisplayFormats.ByName[pliType].Value.displayFormat;
    
    let roundingValue = Enums.TbaPliDisplayFormats.ByName[pliType] && Enums.TbaPliDisplayFormats.ByName[pliType].Value.roundingValue;

    if (isDecimal && Number(isDecimal)) {
      formatted = this.roundValue(Number(value), -roundingValue).toFixed(roundingValue);
    }

    formatted = formatted || `${this.roundValue((Number(value + 'e2')), -roundingValue).toFixed(roundingValue)}%`;

    return formatted === 'NaN' ? value : formatted;
  }
  
  roundValue(value: number, exp: number) {
    if (typeof exp === 'undefined' || Number(exp) === 0) {
      return Math.round(value);
    }
    value = Number(value);
    exp = Number(exp);
    if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
      return NaN;
    }
    const convertedIntegerValue = Math.round(Number(value + 'e' + (-exp)));
    const backToFloatValue = Number(convertedIntegerValue + 'e' + exp);

    return backToFloatValue;
  }

}
